import React from "react";
import styled from "styled-components";
import DataTable from "src/components/Table";
import TableRow from "src/components/Table/TableRow";
import { ID, LocationForTable } from "src/types";
// import { formatTimezoneToShort } from "src/utils/time";
import { Cell } from "../../../../components/Table/Cell";

export interface LocationsTable {
  isLoading: boolean;
  headers: string[];
  data: LocationForTable[];
  onRowClick: (id: ID, label: string) => void;
}

export const LocationsTable = ({ isLoading, headers, data, onRowClick }: LocationsTable) => {
  return (
    <TableWrapper>
      <DataTable isLoading={isLoading} headers={headers}>
        <>
          {data?.map(({ id, label, address, clientName }: LocationForTable) => {
            return (
              <TableRow onClick={() => onRowClick(id, label)} $clickable key={id}>
                <Cell>{id.toString() ?? "N/A"}</Cell>
                <Cell>{label || "N/A"}</Cell>
                <Cell>{address || "N/A"}</Cell>
                {clientName && <Cell>{clientName}</Cell>}
                {/* <Cell>{formatTimezoneToShort(timezone)}</Cell> */}
              </TableRow>
            );
          })}
        </>
      </DataTable>
    </TableWrapper>
  );
};

const TableWrapper = styled.div`
  table {
    table-layout: fixed;
  }

  th:nth-child(1),
  td:nth-child(1) {
    width: 80px;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 220px;
  }

  th:nth-child(3),
  td:nth-child(3) {
    width: 420px;
  }
`;
